Updates the personal details of an uploaded candidate.
